<template lang="pug">
    include TrainerDetailAddress.pug
</template>

<script>

export default {
    name: 'TrainerDetailAddress',
    props: ["trainer", "mode", "presentation"],
    computed: {
        list_address() {
            let items = [];
            if (this.trainer.zip_code) items.push(this.trainer.zip_code);
            if (this.trainer.city) items.push(this.trainer.city);
            if (!items.length) return null;
            return items.join(" - ");
        },
    },
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "TrainerDetailAddress";
</style>



// WEBPACK FOOTER //
// src/components/trainer_detail_address/TrainerDetailAddress.vue